import graphReactor from '@/graphReactor';
import highway from '@/plugins/highway';

const setOpacityLabel = (item, val) => {
  graphReactor.exploreInstance.updateItem(item, {
    labelCfg: {
      style: {
        opacity: val,
      },
    },
  });
};

const clearStates = () => {
  graphReactor.exploreInstance.getNodes().forEach((node) => {
    graphReactor.exploreInstance.clearItemStates(node);
    setOpacityLabel(node, 1);
  });
  graphReactor.exploreInstance.getEdges().forEach((edge) => {
    graphReactor.exploreInstance.clearItemStates(edge);
    setOpacityLabel(edge, 1);
  });

  graphReactor.exploreInstance.getCombos().forEach((combo) => {
    graphReactor.exploreInstance.clearItemStates(combo);
  });
};

export default (nodeModel) => {
  clearStates();
  graphReactor.exploreInstance.getNodes().forEach((node) => {
    graphReactor.exploreInstance.setItemState(node, 'opacityO', true);
    setOpacityLabel(node, 0.1);
    // }
  });
  graphReactor.exploreInstance.getEdges().forEach((edge) => {
    graphReactor.exploreInstance.setItemState(edge, 'opacityO', true);
    setOpacityLabel(edge, 0.1);
  });
  graphReactor.exploreInstance.setItemState(nodeModel.id, 'focusEd', true);
  graphReactor.exploreInstance.getNeighbors(nodeModel.id).forEach((neighbor) => {
    graphReactor.exploreInstance.setItemState(neighbor, 'relatedEd', true);
    setOpacityLabel(neighbor, 1);
  });
  const findEdge = graphReactor.exploreInstance.findAll('edge', (edge) => {
    if (edge.get('model').source === nodeModel.id || edge.get('model').target === nodeModel.id) {
      return true;
    }
    return false;
  });
  findEdge.forEach((edge) => {
    graphReactor.exploreInstance.setItemState(edge, 'relatedEd', true);
    setOpacityLabel(edge, 1);
  });
  // focusItem
  graphReactor.exploreInstance.focusItem(nodeModel.id);
  highway.excludeDispatcher(nodeModel.label, ['gmodule/exploreGraphFetch']);
};
